import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { IconButton, IIconButtonProps } from "../../organization/sharedComponents/IconButton/IconButton";
import { useFaCollapsibleContext } from "../FaCollapsibleContext/FaCollapsibleContext";
import "./faCollapsibleIcon.scss";

interface IFaCollapsibleIconProps extends IIconButtonProps { }

export function FaCollapsibleIcon(props: IFaCollapsibleIconProps) {
    const { disabled, open } = useFaCollapsibleContext();

    if (props.disabled || disabled) {
        return null;
    }

    return (
        <IconButton color="dark" fill="clear" {...props} className={clsx("fa-collapsible-icon", props.className)}>
            <FontAwesomeIcon
                icon={faChevronDown}
                className={clsx("fa-collapsible-icon__icon", {
                    "fa-collapsible-icon__icon--opened": open,
                    "fa-collapsible-icon__icon--closed": !open,
                })}
            />
        </IconButton>
    );
}
